import { Api } from '@/services/Api'

export default {
  fetchScbTableData(param) {
    return Api().post('/api/v2/scb/table', param)
  },
  fetchScbGraphData(param) {
    return Api().post('/api/v2/scb/graph', param)
  }
}